import {
    h,
    renderSlot,
    computed,
} from 'vue'

import {
    useAField,
} from './model.js'

import {
    useUUID,
    useGetListeners,
} from '../utils'

import './style.scss'

const AField = {
    name: 'AField',
    inheritAttrs: false,
    props: {
        label: {
            type: String,
            default: 'Field'
        },
        staticLabel: {
            type: Boolean,
            default: false,
        },
        placeholder: {
            type: String,
            default: '',
        },
        error: {
            type: Boolean,
            default: false,
        },
        type: String,
        labelClass: {
            type: String || Array,
            default: 'label'
        },
        hint: String,
        errorMsg: {
            type: Array,
            default: null,
        },
        modelValue: {
            required: false,
            default: ''
        },
        validator: {
            type: Function,
        },
        state: {
            type: Object,
            default: () => ({})
        },
        listeners: Array,
    },
    setup: (props, ctx) => {
        
        const {
            store,
            focusIn,
            focusOut,
            validate,
        } = useAField(props, ctx)

        const listeners = useGetListeners(props.listeners, ctx)
        const uuid = ctx.attrs.id ? ctx.attrs.id : useUUID()

        const classes = computed(() => {
            store.state.error = props.error
            return store.state
        })

        const renderField = () => h('div', {
            // ...ctx.attrs,
            // ...store.state.listeners,
            ...listeners,
            onMousedown: $e => ctx.emit($e.type, $e),
            class: [classes.value, ctx.attrs.class, props.type === 'file' ? 'a-field-file' : ''],
        }, [
            props.staticLabel ? labelSlot() : '',
            beforeSlot(),
            contentSlot(),
            afterSlot(),
            ctx.slots.error !== void 0 || props.hint ? bottomSlot() : ''
        ])

        const labelSlot = () => renderSlot(ctx.slots, 'label', {
            ...props,
            ...store,
        }, () => [h('label', {
            class: [props.labelClass, props.type === 'file' && 'active'],
            innerHTML: props.label,
            for: uuid,
        })])

        const beforeSlot = () => {
            return ctx.slots.before !== void 0 ?
                h('div', {
                    class: ['field-before'],
                }, [renderSlot(ctx.slots, 'before', {
                    ...props
                })]) : renderSlot(ctx.slots, 'before')
        }

        const afterSlot = () => {
            return ctx.slots.after !== void 0 ?
                h('div', {
                    class: ['field-after'],
                }, [renderSlot(ctx.slots, 'after')]) : renderSlot(ctx.slots, 'after')
        }

        const prependSlot = () => {
            return ctx.slots.prepend !== void 0 ?
                h('div', {
                    class: ['field-prepend'],
                }, [renderSlot(ctx.slots, 'prepend')]) : renderSlot(ctx.slots, 'prepend')
        }

        const appendSlot = () => {
            return ctx.slots.append !== void 0 ?
                h('div', {
                    class: ['field-append'],
                }, [renderSlot(ctx.slots, 'append')]) : renderSlot(ctx.slots, 'append')
        }

        const bottomSlot = () => {
            return ctx.slots.error !== void 0 ?
                h('div', {
                    class: ['field-bottom'],
                }, [
                    h('div', {
                        class: 'field-hint'
                    }, props.hint),
                    props.state.errorMsg && h('div', {
                        class: 'field-error-msg'
                    }, props.state.errorMsg)
                ]) :
                h('div', {
                    class: ['field-bottom'],
                }, [
                    props.hint && h('div', {
                        class: 'field-hint'
                    }, props.hint),
                    renderSlot(ctx.slots, 'bottom')
                ])
        }

        const contentSlot = () => {
            return ctx.slots.content !== void 0 ?
                renderSlot(ctx.slots, 'content', {
                    ...props,
                    ...store,
                }) :
                h('div', {
                    class: ['field-content'],
                }, [
                    prependSlot(),
                    controlWrapSlot(),
                    appendSlot(),
                    // bottomSlot(),
                ])
        }

        const controlWrapSlot = () => {
            return ctx.slots.controlWrap !== void 0 ?
                renderSlot(ctx.slots, 'controlWrap', {
                    ...props,
                    ...store,
                }) :
                h('div', {
                    class: ['control-wrap'],
                    tabindex: -1,
                    onFocusin: $e => focusIn($e),
                    onFocusout: $e => {
                        focusOut($e)
                        if (props.validator) {
                            validate()
                        }
                    },
                }, [
                    !props.staticLabel ? labelSlot() : '',
                    props.type === 'file' ? h('label', {
                        class: ['a-field-file-input'],
                        for: uuid,
                    }, [
                        !props.modelValue || typeof props.modelValue === 'object' && props.modelValue.length === 0 ? h('div', {
                            class: ['a-field-file-input-placeholder'],
                        }, props.placeholder) : '',
                        props.modelValue ? h('div', {
                            class: ['a-field-file-input-value'],
                        }, props.modelValue[0] ? props.modelValue[0].name : '') : ''
                    ]) : '',
                    props.type === 'password' ? [h('div', {
                        class: ['a-field-password-toggle'],
                        onClick: $e => {
                            const input = $e.target.parentNode.querySelector('input')
                            if (input) {
                                input.type = input.type === 'password' ? 'input' : 'password'
                            }
                            $e.target.classList.contains('show') ? $e.target.classList.remove('show') : $e.target.classList.add('show')
                        }
                    }, [])] : '',
                    controlSlot(),
                ])
        }

        const controlSlot = () => {
            return ctx.slots.control !== void 0 ?
                ctx.slots.control({
                    uuid: uuid,
                    ...props,
                    ...store,
                }) :
                h('div', {
                    class: ['control'],
                    id: uuid
                })
        }

        return {
            renderField,
            store,
            validate,
            focusIn,
            focusOut
        }
    },
    render() {
        return this.renderField()
    }
}

export {
    AField
}